import { render, staticRenderFns } from "./SearchDisasterTypes.vue?vue&type=template&id=79d7f816"
import script from "./SearchDisasterTypes.vue?vue&type=script&lang=js"
export * from "./SearchDisasterTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports